module.exports = __webpack_public_path__ + "media/images/lesson_7/nini_com_sucesso-a08cfa48765f6e9bd69908ec2f172e90.png";